import { Injectable } from '@angular/core';

function _window(): any {
    // return the global native browser window object
    if (typeof window !== 'undefined') {
        return window || {};
    } else {
        return {};
    }
}

@Injectable()
export class WindowRef {
    get nativeWindow(): any {
        return _window();
    }
}
